import React, { useContext, useEffect, useState } from "react";

// packages
import styled from "styled-components";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { Context } from "../../contexts/Store";
import { authentication } from "../../axiosConfig";

function LoginPage() {
    const navigate = useNavigate();
    //states
    const [email, setEmail] = useState("");

    const [isChecked, setChecked] = useState(false);
    const [viewPassword, setViewPassword] = useState(false);
    const [username, setUsername] = useState("");
    const [password, SetPassword] = useState("");
    const [error, setError] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const { dispatch } = useContext(Context);

    const handleSubmit = () => {
        // if (isChecked) {
        if (username != null && password != null) {
            setIsLoading(true);
            setError("");
            authentication
                .post("/login/", {
                    email,
                    password,
                })
                .then(function (response) {
                    const { StatusCode } = response.data;
                    const { access_token, refresh_token, message } =
                        response.data.data;

                    if (StatusCode == 6000) {
                        dispatch({
                            type: "UPDATE_USER",
                            user_details: {
                                is_verified: true,
                                access_token: access_token,
                                user_id: response.data.data.user_id,
                                role: response.data.data.roles,
                            },
                        });
                        setIsLoading(false);
                        navigate("/");
                    } else if (StatusCode == 6001) {
                        setError(response.data.data.message);
                        setIsLoading(false);
                    } else {
                        alert("Some error occured. Please try later");
                        setIsLoading(false);
                    }
                })
                .catch(function (error) {
                    setError(error.response.data.data.message);
                    setIsLoading(false);
                });
            // }
            // setError("please fill all the fields");
        }
    };
    useEffect(() => {
        setTimeout(() => {
            setError("");
        }, 2000);
        let user_details = localStorage.getItem("user_details");
        user_details = JSON.parse(user_details);
        dispatch({ type: "UPDATE_USER", user_details: user_details });
    }, [setError]);

    useEffect(() => {
        if (error) {
            setTimeout(() => {
                setError("");
            }, 9000);
        }
    }, [error]);

    return (
        <Main>
            <Wrapper>
                <Left>
                    <ImageBox>
                        <img
                            src={require("../../assets/image/loginpage/loginpageimage.png")}
                            alt="loginimage"
                        />
                    </ImageBox>
                    <AboutSection>
                        <AboutTitle>About MindMitra</AboutTitle>
                        <AboutText>
                        Mindmitra is a patient centric company working to provide easy and affordable access to mental wellness by leveraging technology.
                        Mindmitra is a team of qualified multi intervention professionals dedicated to providing technology supported mental health consultation, 
                        and assist to individuals and families with psychological needs. 
                        We realised during our professional journey that majority of the society still shy away from taking help when they are mentally disturbed and often try to avoid importance of mental health. 
                        There are difficulties like lack of quality mental health support at reasonable price, 
                        accessibility to good care at remote areas etc. 
                        We are trying to solve these issues with the help of our online counselling and therapy platform (One step at a time!).
                        </AboutText>
                        <ContactInfo>
                            <ContactTitle>Contact Us</ContactTitle>
                            <ContactItem>
                                <ContactIcon>📧</ContactIcon>
                                <span>expertcare@mymindmitra.com</span>
                            </ContactItem>
                            <ContactItem>
                                <ContactIcon>📞</ContactIcon>
                                <span>+91 8075656112,
                                9188386292</span>
                            </ContactItem>
                            <ContactItem>
                                <ContactIcon>📍</ContactIcon>
                                <span>Eruppakkil,katampazhippuram,Palakkad ,678633</span>
                            </ContactItem>
                        </ContactInfo>
                    </AboutSection>
                </Left>
                <Right>
                    <LogoBox>
                        <img
                            src={
                                require("../../assets/image/loginpage/logo.svg")
                                    .default
                            }
                            alt="logo"
                        />
                    </LogoBox>
                    <TopText>
                        <Titile>Welcome Again, Login</Titile>
                        <SubTitile>
                            Welcome to the MindMitra community of <br /> expert
                            psychologists!
                        </SubTitile>
                    </TopText>
                    <Inputs>
                        <InputUser>
                            <UserBox>
                                <img
                                    src={
                                        require("../../assets/image/loginpage/account_circle.svg")
                                            .default
                                    }
                                    alt="account_circle"
                                />
                            </UserBox>
                            <input
                                type="email"
                                placeholder="Enter your Email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            ></input>
                        </InputUser>
                        <InputBox>
                            <PassBox>
                                <img
                                    src={
                                        require("../../assets/image/loginpage/lock.svg")
                                            .default
                                    }
                                    alt="lock"
                                />
                            </PassBox>
                            <input
                                type={viewPassword ? "text" : "password"}
                                placeholder="Enter Password"
                                name="password"
                                required
                                value={password}
                                onChange={(e) => {
                                    SetPassword(e.target.value.slice(0, 30));
                                    setError("");
                                }}
                            ></input>
                            <Eye onClick={() => setViewPassword(!viewPassword)}>
                                <img
                                    src={
                                        viewPassword
                                            ? require("../../assets/image/loginpage/eye-closed.svg")
                                                  .default
                                            : require("../../assets/image/loginpage/visibility.svg")
                                                  .default
                                    }
                                    alt="visibility"
                                />
                            </Eye>
                        </InputBox>
                    </Inputs>
                    {error && <ErrorRed>{error}</ErrorRed>}
                    <ForContainer>
                        <For to="/auth/forgot-password">Forget Password?</For>
                    </ForContainer>

                    <ButtonBox
                        onClick={() => {
                            if (email == "" && password == "") {
                                setError("Please fill all the fields");
                            } else if (password == "") {
                                setError("Please enter password");
                            } else if (email == "") {
                                setError("Please enter a valid email");
                            } else {
                                handleSubmit();
                            }
                        }}
                    >
                        Login
                    </ButtonBox>
                    <Expert>
                        Don't you have an account?{" "}
                        <Log to="/auth/register-page"> Create Account</Log>{" "}
                    </Expert>
                    
                    <FooterLinks>
                        <FooterLink to={'/auth/faqs'}>FAQ</FooterLink>
                        <FooterLink to={'/auth/terms-and-conditions'}>Terms & Conditions</FooterLink>
                        <FooterLink to={'/auth/privacy-policy'}>Privacy Policy</FooterLink>
                    </FooterLinks>
                </Right>
            </Wrapper>
        </Main>
    );
}

export default LoginPage;
const Eye = styled.div`
    width: 25px;
    margin-right: 15px;
    margin-top: 7px;
    img {
        display: block;
        width: 100%;
    }
`;
const UserBox = styled.div`
    margin-top: 5px;
`;
const PassBox = styled.div`
    margin-top: 5px;
`;
const Check = styled.div`
    display: flex;
    color: #818181;
    margin-left: 10px;
    @media all and (max-width: 1280px) {
        font-size: 14px;
    }
`;
const TCBox = styled(Link)`
    text-decoration: underline;
    color: #366ee3;
    margin-left: 5px;
`;

const Inputs = styled.div`
    margin-bottom: 10px;
`;
const Box = styled.div`
    margin-bottom: 20px;
    display: flex;
`;
const CheckBox = styled.div`
    width: 19px;
    height: 19px;
    border-radius: 5px;
    margin-top: 1px;
    cursor: pointer;
    border: 1px solid #c1bfbf;
    @media all and (max-width: 1280px) {
        margin-top: 0;
        width: 15px;
        height: 15px;
    }
    img {
        display: block;
        width: 100%;
        height: 100%;
    }
`;
const ForContainer = styled.div`
    width: 80%;
    margin-bottom: 15px;
    display: flex;
    justify-content: flex-end;
`;
const For = styled(Link)`
    text-decoration: underline;
    color: #2b3990;
    text-align: end;
    display: block;

    @media all and (max-width: 1280px) {
        font-size: 12px;
    }
`;
const Main = styled.div`
    padding: 70px 0;
`;
const Wrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 100px;
    width: 90%;
    margin: 0 auto;
    @media all and (max-width: 980px) {
        flex-direction: column-reverse;
        gap: 50px;
    }
`;
const Left = styled.div`
    width: 55%;
    @media all and (max-width: 1440px) {
    }
    @media all and (max-width: 1050px) {
        width: 64%;
    }
    @media all and (max-width: 980px) {
        width: 85%;
    }
`;
const ImageBox = styled.div`
    align-items: center;
    width: 100%;
    @media all and (max-width: 980px) {
        width: 100%;
    }
    img {
        width: 100%;
        display: block;
    }
`;
const Right = styled.div`
    width: 40%;
    @media all and (max-width: 1440px) {
    }
    @media all and (max-width: 980px) {
        width: 75%;
    }
`;
const LogoBox = styled.div`
    width: 16%;
`;
const TopText = styled.div``;
const Titile = styled.h5`
    font-size: 24px;
    font-family: "DM_sans_bold";
    margin: 30px 0 7px 0;

    @media all and (max-width: 1440px) {
        margin-top: 15px;
    }
    @media all and (max-width: 1050px) {
        font-size: 22px;
    }
`;
const SubTitile = styled.p`
    color: #7a838a;
    font-size: 16px;
    font-weight: 300;
    line-height: 20px;
    @media all and (max-width: 1050px) {
        font-size: 14px;
    }
`;

const InputUser = styled.div`
    background-color: #f6f7f9;
    display: flex;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 300;
    padding: 10px 20px;
    align-items: center;
    margin-top: 50px;
    width: 80%;
    @media all and (max-width: 1280px) {
    }

    input {
        border: none;
        background-color: #f6f7f9;
        padding-left: 10px;
        font-size: 18px;
        width: 100%;
        height: 100%;
        box-sizing: border-box;

        ::placeholder {
            font-size: 14px;
            font-weight: 400;
        }
    }
`;
const InputBox = styled.div`
    background-color: #f6f7f9;
    display: flex;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 300;
    padding: 10px 20px;
    align-items: center;
    margin-top: 10px;
    width: 80%;
    @media all and (max-width: 1280px) {
    }
    input {
        border: none;
        background-color: #f6f7f9;
        padding-left: 10px;
        height: 100%;
        box-sizing: border-box;
        font-size: 18px;
        width: 100%;

        ::placeholder {
            font-size: 14px;
            font-weight: 400;
        }
    }
`;
const ButtonBox = styled.button`
    background-color: #366ee3;
    color: #fff;
    text-align: center;
    padding: 15px 160px;
    text-decoration: none;
    border-radius: 8px;
    margin-top: 5px;
    width: 100%;
    border: none;
    cursor: pointer;
    width: 80%;
`;
const Log = styled(Link)`
    color: #2b3990;
    text-decoration: underline;
`;
const Expert = styled.h5`
    font-size: 16px;
    font-weight: 300;
    cursor: pointer;
    text-align: center;
    color: #818181;
    margin-top: 20px;
    width: 80%;
    @media all and (max-width: 1280px) {
        font-size: 15px;
    }
`;
const ErrorRed = styled.div`
    color: red;
    font-size: 14px;
    margin-top: 20px;
`;

// New styled components for About Us and Contact sections
const AboutSection = styled.div`
    margin-top: 30px;
    padding: 20px;
    background-color: #f8f9fa;
    border-radius: 10px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
`;

const AboutTitle = styled.h3`
    font-size: 22px;
    color: #2b3990;
    margin-bottom: 15px;
    font-family: "DM_sans_bold";
`;

const AboutText = styled.p`
    font-size: 15px;
    line-height: 1.6;
    color: #555;
    margin-bottom: 20px;
`;

const ContactInfo = styled.div`
    margin-top: 20px;
`;

const ContactTitle = styled.h4`
    font-size: 18px;
    color: #2b3990;
    margin-bottom: 12px;
    font-family: "DM_sans_bold";
`;

const ContactItem = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    font-size: 14px;
    color: #555;
`;

const ContactIcon = styled.span`
    margin-right: 10px;
    font-size: 16px;
`;

// Footer links styling
const FooterLinks = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 30px;
    width: 80%;
    flex-wrap: wrap;
    gap: 15px;
`;

const FooterLink = styled(Link)`
    color: #7a838a;
    font-size: 14px;
    text-decoration: none;
    position: relative;
    
    &:hover {
        color: #366ee3;
        text-decoration: underline;
    }
    
    &:not(:last-child):after {
        content: '|';
        position: absolute;
        right: -10px;
        color: #d1d1d1;
    }
`;
